import { NgModule } from '@angular/core';
import { RolesRoutingModule } from './roles-routing.module';
import { PluginService } from '../../plugins/services/plugin.service';
import { RolePermissionPlugin } from '../../authentication/plugins/role-permission/role-permission.plugin';
import { CreateUserRoleModal } from '../../authentication/modals/create-user-role/create-user-role.modal';
import { FormsModule } from '../../forms/forms.module';
import { ChassisModalModule } from '../../modals/modals.module';
import { EditUserRoleModal } from '../../authentication/modals/edit-user-role/edit-user-role.modal';
import { PermissionService } from '../../authentication/services/permission.service';
import { RolePermissionService } from '../../authentication/services/role-permission.service';

@NgModule({
    imports: [ RolesRoutingModule, FormsModule, ChassisModalModule ],
    exports: [],
    declarations: [ CreateUserRoleModal, EditUserRoleModal ],
    entryComponents: [ CreateUserRoleModal, EditUserRoleModal ],
    providers: [ PermissionService, RolePermissionService ],
})
export class RolesModule {

    public constructor(plugins: PluginService) {

        // Roles (after => permissions)
        const prefixes = [ 'chassis-core-role' ];
        const modes    = [ 'create', 'edit' ];
        const suffixes = [ 'after' ];
        for (const prefix of prefixes) {
            for (const mode of modes) {
                for (const suffix of suffixes) {
                    const slot = prefix + '-' + mode + '-' + suffix;
                    plugins.add(slot, 'core-role-permissions', RolePermissionPlugin);
                }
            }
        }

        // plugins.add('chassis-core-role-create-after', 'core-permission-roles', RolePermissionPlugin);
        // plugins.add('chassis-core-role-edit-after', 'core-permission-roles', RolePermissionPlugin);
    }

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/pages/roles/roles.module.ts